module.exports = "/_next/static/images/fe1ff91bb2d34618bdded6db10491966-nucommunity-xs@1x.jpg.webp";